import React from 'react';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const styles = {
    topMessage: {
        fontWeight: 'bold',
        fontFamily: 'auto'
    },
    bottomMessage: {
        textAlign: 'center',
        fontFamily: 'monospace',
        lineHeight: 1,
    }
}

const TopWelcomeMessages = () => {

    return (
        <Grid style={{
            paddingTop: 40,
            paddingLeft: 40,
            paddingRight: 40,
            paddingBottom: 40,
        }} container item xs direction='column' alignItems='center' alignContent='center'>

            <Typography style={styles.topMessage} variant='h3'>
                WELCOME
            </Typography>

            <Typography variant='subtitle1' style={styles.bottomMessage}>
                SHARE YOUR S3CR3T MESSAGES EASILY AND EFFECTIVELY. NO REGISTRATIONS REQUIRED. SAVE/DELETE FROM ANYWHERE.
                FREE FOREVER.
            </Typography>
        </Grid>
    );
};

export default TopWelcomeMessages;
